export default __webpack_public_path__ + "static/media/AB&T.d467f6d0.png";